import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActiveBagsTable = ({ bags = [], onUpdateBag, onGenerateQR, className = '' }) => {
  const [selectedBags, setSelectedBags] = useState([]);

  const mockBags = [
  {
    id: 1,
    title: "Bolsa Sorpresa de Panadería",
    originalPrice: 200,
    discountedPrice: 100,
    category: "Panadería",
    quantity: 3,
    interested: 8,
    timeRemaining: "2h 15m",
    status: "active",
    publishedAt: new Date(Date.now() - 45 * 60 * 1000),
    pickupTime: "18:00",
    image: "https://images.unsplash.com/photo-1735196454533-9ea92da29040",
    imageAlt: "Fresh assorted bread and pastries displayed in bakery basket"
  },
  {
    id: 2,
    title: "Comida Casera Sorpresa",
    originalPrice: 150,
    discountedPrice: 75,
    category: "Restaurante",
    quantity: 2,
    interested: 12,
    timeRemaining: "45m",
    status: "urgent",
    publishedAt: new Date(Date.now() - 3 * 60 * 60 * 1000),
    pickupTime: "15:30",
    image: "https://images.unsplash.com/photo-1551750643-000f8e89c7dc",
    imageAlt: "Homestyle prepared meal with rice, vegetables and meat in takeout container"
  },
  {
    id: 3,
    title: "Postres del Día",
    originalPrice: 120,
    discountedPrice: 60,
    category: "Postres",
    quantity: 5,
    interested: 6,
    timeRemaining: "4h 30m",
    status: "active",
    publishedAt: new Date(Date.now() - 30 * 60 * 1000),
    pickupTime: "20:00",
    image: "https://images.unsplash.com/photo-1570883920296-0174a206d2be",
    imageAlt: "Assorted colorful desserts including cakes, pastries and sweet treats on display"
  }];


  const displayBags = bags?.length > 0 ? bags : mockBags;

  const getStatusColor = (status) => {
    switch (status) {
      case 'urgent':
        return 'text-error bg-error/10';
      case 'active':
        return 'text-success bg-success/10';
      case 'sold':
        return 'text-muted-foreground bg-muted';
      default:
        return 'text-foreground bg-muted';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'urgent':
        return 'Urgente';
      case 'active':
        return 'Activo';
      case 'sold':
        return 'Vendido';
      default:
        return 'Desconocido';
    }
  };

  const handleSelectBag = (bagId) => {
    setSelectedBags((prev) =>
    prev?.includes(bagId) ?
    prev?.filter((id) => id !== bagId) :
    [...prev, bagId]
    );
  };

  const handleSelectAll = () => {
    if (selectedBags?.length === displayBags?.length) {
      setSelectedBags([]);
    } else {
      setSelectedBags(displayBags?.map((bag) => bag?.id));
    }
  };

  const handleBulkAction = (action) => {
    console.log(`Bulk action: ${action} for bags:`, selectedBags);
    setSelectedBags([]);
  };

  const formatTimeAgo = (date) => {
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);

    if (minutes < 60) return `hace ${minutes}m`;
    return `hace ${hours}h`;
  };

  return (
    <div className={`bg-card border border-border rounded-lg ${className}`}>
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-heading font-semibold text-foreground">
              Bolsas Activas
            </h2>
            <p className="text-sm text-muted-foreground mt-1">
              Gestiona tus publicaciones actuales
            </p>
          </div>
          
          {selectedBags?.length > 0 &&
          <div className="flex items-center space-x-2">
              <span className="text-sm text-muted-foreground">
                {selectedBags?.length} seleccionadas
              </span>
              <Button
              variant="outline"
              size="sm"
              onClick={() => handleBulkAction('edit')}>

                <Icon name="Edit" size={14} className="mr-1" />
                Editar
              </Button>
              <Button
              variant="destructive"
              size="sm"
              onClick={() => handleBulkAction('delete')}>

                <Icon name="Trash2" size={14} className="mr-1" />
                Eliminar
              </Button>
            </div>
          }
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/30">
            <tr>
              <th className="text-left p-4">
                <input
                  type="checkbox"
                  checked={selectedBags?.length === displayBags?.length && displayBags?.length > 0}
                  onChange={handleSelectAll}
                  className="rounded border-border" />

              </th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Producto
              </th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Precio
              </th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Estado
              </th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Interesados
              </th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Tiempo Restante
              </th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {displayBags?.map((bag) =>
            <tr key={bag?.id} className="border-b border-border hover:bg-muted/20 transition-colors">
                <td className="p-4">
                  <input
                  type="checkbox"
                  checked={selectedBags?.includes(bag?.id)}
                  onChange={() => handleSelectBag(bag?.id)}
                  className="rounded border-border" />

                </td>
                
                <td className="p-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 rounded-md overflow-hidden bg-muted flex-shrink-0">
                      <img
                      src={bag?.image}
                      alt={bag?.imageAlt}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.src = 'publicpublic/assets/images/slazzer-preview-av4u0-1762512006110.png';
                      }} />

                    </div>
                    <div className="min-w-0 flex-1">
                      <h3 className="font-medium text-foreground truncate">
                        {bag?.title}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {bag?.category} • Publicado {formatTimeAgo(bag?.publishedAt)}
                      </p>
                    </div>
                  </div>
                </td>
                
                <td className="p-4">
                  <div className="text-sm">
                    <div className="font-medium text-foreground">
                      ${bag?.discountedPrice}
                    </div>
                    <div className="text-muted-foreground line-through">
                      ${bag?.originalPrice}
                    </div>
                  </div>
                </td>
                
                <td className="p-4">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(bag?.status)}`}>
                    {getStatusLabel(bag?.status)}
                  </span>
                </td>
                
                <td className="p-4">
                  <div className="flex items-center space-x-1">
                    <Icon name="Users" size={14} color="var(--color-muted-foreground)" />
                    <span className="text-sm font-medium text-foreground">
                      {bag?.interested}
                    </span>
                  </div>
                </td>
                
                <td className="p-4">
                  <div className="text-sm">
                    <div className={`font-medium ${bag?.status === 'urgent' ? 'text-error' : 'text-foreground'}`}>
                      {bag?.timeRemaining}
                    </div>
                    <div className="text-muted-foreground">
                      hasta {bag?.pickupTime}
                    </div>
                  </div>
                </td>
                
                <td className="p-4">
                  <div className="flex items-center space-x-2">
                    <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onGenerateQR?.(bag?.id)}>

                      <Icon name="QrCode" size={14} />
                    </Button>
                    <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onUpdateBag?.(bag?.id)}>

                      <Icon name="Edit" size={14} />
                    </Button>
                    <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => console.log('View details', bag?.id)}>

                      <Icon name="Eye" size={14} />
                    </Button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {displayBags?.length === 0 &&
      <div className="p-12 text-center">
          <Icon name="Package" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
          <h3 className="font-heading font-medium text-foreground mb-2">
            No hay bolsas activas
          </h3>
          <p className="text-muted-foreground text-sm">
            Publica tu primera bolsa sorpresa para comenzar
          </p>
        </div>
      }
    </div>);

};

export default ActiveBagsTable;